package dev.lingvo.site.components.studio.compose

import dev.lingvo.shared.screenshots.render.RenderReport
import dev.lingvo.site.components.studio.fonts.FontLoadProgress

/** Font failures stop the run before allocating its canvas. */
data class FontPreflightResult(val ready: Boolean, val message: String? = null)

/** Export renderer owns auxiliary images only between prepare and closeJob. */
interface ComposeRenderPort {
    val ownedBitmaps: Int get() = 0
    suspend fun ensureFonts(jobs: List<ComposeJob>): FontPreflightResult
    suspend fun ensureFonts(jobs: List<ComposeJob>, progress: (FontLoadProgress) -> Unit): FontPreflightResult = ensureFonts(jobs)
    suspend fun prepare(job: ComposeJob) {}
    fun render(job: ComposeJob, capture: dynamic, target: dynamic): RenderReport
    fun closeJob() {}
}
